import React, { useCallback, useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { useTenantContext } from '../../../tenant/TenantContext';
import { useNavigate } from 'react-router-dom';
import { useFilterContext } from '../infrastructure/FilterContext';

import { SearchContainer, SearchInput, SearchIconWrapper } from './filter-panel/ProductSearchFilter.styles';

export const ProductSearchFilter = () => {
    useTenantContext();
    const { updateFilters, filters } = useFilterContext();
    const [searchString, setSearchString] = useState(filters?.search || '');
    const navigate = useNavigate();

    const searchProduct = useCallback(
        (searchTerm) => {
            updateFilters({ search: searchTerm });
            navigate('/articulos');
        },
        [navigate, updateFilters]
    );

    const handleChange = (event) => {
        event.preventDefault();
        setSearchString(event.target.value);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            searchProduct(searchString);
        }
    };

    useEffect(() => {
        setSearchString(filters?.search || '');
    }, [filters]);

    return (
        <div className="w-100 d-flex flex-column gap-2 align-items-center">
            <SearchContainer>
                <SearchInput
                    placeholder="Busca aquí tus productos"
                    value={searchString}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    type="text"
                />
                <SearchIconWrapper onClick={() => searchProduct(searchString)}>
                    <SearchIcon />
                </SearchIconWrapper>
            </SearchContainer>
        </div>
    );
};
